/**
 * @generated SignedSource<<4a8ef5bc404be8914ca884b230007533>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type userProfileApplicationStatusFragment$data = {
  readonly onboardingStatus: string | null;
  readonly applicationStatus: string | null;
  readonly documentStatus: string | null;
  readonly profileStatus: string | null;
  readonly setupCompletedAt: any | null;
  readonly onboardingApprovedAt: any | null;
  readonly applicationApprovedAt: any | null;
  readonly " $fragmentType": "userProfileApplicationStatusFragment";
};
export type userProfileApplicationStatusFragment$key = {
  readonly " $data"?: userProfileApplicationStatusFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"userProfileApplicationStatusFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "userProfileApplicationStatusFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "onboardingStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "applicationStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "setupCompletedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "onboardingApprovedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "applicationApprovedAt",
      "storageKey": null
    }
  ],
  "type": "UserProfileDetailConnect",
  "abstractKey": null
};

(node as any).hash = "c3dca988458aef861da1976efc7d8ea7";

export default node;
